import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import { Toaster } from "@/components/ui/sonner";

import PhpLandingPage from "@/pages/PhpLandingPage";
import PresentationPage from "@/pages/PresentationPage";
import TarifsPage from "@/pages/TarifsPage";
import ContactPage from "@/pages/ContactPage";
import DemoPage from "@/pages/DemoPage";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import LegalPage from "@/pages/LegalPage";
import Home from "@/pages/Home";
import AccessDenied from "@/pages/AccessDenied";
import Login from "@/pages/Login";
import AdminLayout from "@/components/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import LinksManager from "@/pages/admin/LinksManager";
import CategoriesManager from "@/pages/admin/CategoriesManager";
import WhitelistManager from "@/pages/admin/WhitelistManager";
import StatsPage from "@/pages/admin/StatsPage";
import AnnouncementsManager from "@/pages/admin/AnnouncementsManager";
import SettingsManager from "@/pages/admin/SettingsManager";
import ProfilePage from "@/pages/admin/ProfilePage";
import LicensesManager from "@/pages/admin/LicensesManager";
import ContactInbox from "@/pages/admin/ContactInbox";
import CommerceManager from "@/pages/admin/CommerceManager";
import IntegrationsManager from "@/pages/admin/IntegrationsManager";
import LegalPagesManager from "@/pages/admin/LegalPagesManager";
import SeoManager from "@/pages/admin/SeoManager";
import CookieConsent from "@/components/CookieConsent";

// Routes où on n'affiche PAS le bandeau (admin)
function CookieConsentRoute() {
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) return null;
  return <CookieConsent />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PhpLandingPage />} />
            <Route path="/presentation" element={<PresentationPage />} />
            <Route path="/tarifs" element={<TarifsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/mentions-legales" element={<LegalPage />} />
            <Route path="/cgv" element={<LegalPage />} />
            <Route path="/confidentialite" element={<LegalPage />} />
            <Route path="/demo/portal" element={<Home />} />
            <Route path="/access-denied" element={<AccessDenied />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="links" element={<LinksManager />} />
              <Route path="categories" element={<CategoriesManager />} />
              <Route path="whitelist" element={<WhitelistManager />} />
              <Route path="announcements" element={<AnnouncementsManager />} />
              <Route path="stats" element={<StatsPage />} />
              <Route path="licenses" element={<LicensesManager />} />
              <Route path="contact" element={<ContactInbox />} />
              <Route path="commerce" element={<CommerceManager />} />
              <Route path="integrations" element={<IntegrationsManager />} />
              <Route path="legal" element={<LegalPagesManager />} />
              <Route path="seo" element={<SeoManager />} />
              <Route path="settings" element={<SettingsManager />} />
              <Route path="profile" element={<ProfilePage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieConsentRoute />
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
